<script setup>
import { ref } from "vue";
import Vedio from "@/components/Vedio/index.vue";
import PartnersCarousel from "@/components/PartnersCarousel/index.vue";
import Business from "@/components/Business/index.vue";
import OurMertics from "@/components/OurMetrics/index.vue";
import Features from "@/components/Features/index.vue";
import Testimonial from "@/components/Testimonial/index.vue";
import Subscribe from "@/components/Subscribe/index.vue";
import DropDown from "@/components/DropDown/index.vue";
import Slider from "@/components/Slider/index.vue";
import AccordionPanel from "@/components/AccordionPanel/index.vue";
import CustomerWarning from "@/components/CustomerWarning/index.vue";
import Footer from "@/components/Footer/index.vue";

const parentSelectedOption = ref(null);
</script>

<template>
  <Vedio />
  <PartnersCarousel />
  <Business />
  <OurMertics />
  <Features />
  <Testimonial />
  <Subscribe />
  <DropDown :options="options" v-model="parentSelectedOption" />
  <Slider />
  <div class="bg-[#F0F0F0] py-10 pb-20 mt-[-30px] rounded-2xl">
    <AccordionPanel
      aria-title="incidents"
      title=" What is fitexpert software? "
    >
      <CustomerWarning></CustomerWarning>
    </AccordionPanel>
    <AccordionPanel
      aria-title="incidents"
      title=" How do I grow my fit expert business?"
    >
      <CustomerWarning></CustomerWarning>
    </AccordionPanel>
    <AccordionPanel
      aria-title="incidents"
      title=" How do I create a fit expert program?"
    >
      <CustomerWarning></CustomerWarning>
    </AccordionPanel>
    <AccordionPanel
      aria-title="incidents"
      title=" Where can I find downloadable software for a fit expert business?"
    >
      <CustomerWarning></CustomerWarning>
    </AccordionPanel>
    <AccordionPanel
      aria-title="incidents"
      title=" How do I create a fit expert program?"
    >
      <CustomerWarning></CustomerWarning>
    </AccordionPanel>
  </div>
  <div class="bg-[#FFF000] relative mb-[-11px] z-[999] rounded-3xl mt-3 py-20">
    <div class="container">
      <div class="flex items-center justify-around px-4">
        <div class="flex flex-col">
          <h1
            class="text-[#000] font-bold text-[100px] font-Approach uppercase"
          >
            join us today
          </h1>
          <p class="text-[#000] text-[30px] font-Inter">
            Lorem ipsum dolor sit amet, consectetur massa.
          </p>
        </div>
        <button
          class="subscripe-btn outline-none w-[286px] gap-2 border-[#FFF000] text-[16px] text-black font-semibold px-5 bg-[#000]"
        >
          <div class="text flex items-center justify-center py-3 gap-3 text-xl">
            <span class="font-bold text-[#FFF000]"> Explore now </span>
            <div class="icon" style="transform: rotate(-45deg)">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                aria-hidden="true"
                role="img"
                class="icon"
                width="22px"
                height="22px"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="m14 18l-1.4-1.45L16.15 13H4v-2h12.15L12.6 7.45L14 6l6 6l-6 6Z"
                ></path>
              </svg>
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
  <Footer />
</template>
<style>
.subscripe-btn {
  clip-path: polygon(
    0 0,
    0 0,
    100% 0,
    100% 0,
    100% calc(100% - 15px),
    calc(100% - 15px) 100%,
    15px 100%,
    0 100%
  );
  border-style: unset;
  overflow: hidden;
  border: 1px solid #fff000;
  background: #fff000;
  transition: 0.2s all ease-in;
  &:hover {
    span {
      color: black;
    }
  }
  &:hover {
    background: transparent;
    color: black;
    border: 1px solid black;
    clip-path: polygon(
      0 0,
      0 0,
      83% 0,
      100% 0,
      136% calc(185% - -30px),
      calc(100% - 15px) 100%,
      186px 299%,
      0 179%
    );
  }
}
</style>
